export const adminBatchSelectionCommon = {
  partialSelected: "Selected first {selected} items ({total} items match the current filters; the remainder is not selected)",
  allSelected: "Selected {count} items",
};

export const adminBatchCommon = {
  publishDrafts: "Batch publish (drafts only)",
  archive: "Batch archive",
  deleteDrafts: "Batch delete (drafts only)",
  confirmDeleteDraftsDescription: "This action cannot be undone.",
  archiveAction: "Archive",
};

export function buildAdminConfirmBatchCommon(entityPlural: string) {
  return {
    publishDraftsTitle: `Publish the selected {count} draft ${entityPlural}?`,
    archiveTitle: `Archive the selected {count} ${entityPlural}?`,
    deleteDraftsTitle: `Delete the selected {count} draft ${entityPlural}?`,
    deleteDraftsDescription: "This action cannot be undone.",
  };
}

export const adminArchivedToggleCommon = {
  showArchived: "Show archived",
  hideArchived: "Hide archived",
  summaryArchivedVisible: "Archived visible: {value}",
};

export function buildAdminSummaryTotal(entityPlural: string) {
  return `Total ${entityPlural}: {count}`;
}

export function buildAdminBatchSelectionMessages(entityPlural: string) {
  return {
    selectDraftsToPublish: `Only draft ${entityPlural} can be published. Please reselect.`,
    selectArchivableToArchive: `No archivable ${entityPlural} are currently selected`,
    selectDraftsToDelete: `Only draft ${entityPlural} can be deleted. Please reselect.`,
  };
}

export function buildAdminBatchResultMessages(entityPlural: string) {
  return {
    batchPublished: `Published {count} ${entityPlural}`,
    batchArchived: `Archived {count} ${entityPlural}`,
    batchDeleted: `Deleted {count} draft ${entityPlural}`,
  };
}
